export function initSiteHeader() {
    const header = document.querySelector('[data-header]');

    if (!header) return;

    const body = document.body;

    const burger = header.querySelector('[data-burger]');
    const overlay = header.querySelector('[data-header-overlay]');
    const mobileMenu = header.querySelector('[data-mobile-menu]');
    const mobileClose = header.querySelector('[data-mobile-close]');

    const desktopNav = header.querySelector('[data-desktop-nav]');
    const mobileNav = header.querySelector('[data-mobile-nav]');

    const desktopActions = header.querySelector('[data-desktop-actions]');
    const mobileActions = header.querySelector('[data-mobile-actions]');

    const desktopBreakpoint = 990;

    const selectors = {
        desktopItem: 'header-nav__item',
        desktopItemHasSubmenu: 'header-nav__item--has-submenu',
        desktopLinkWrap: 'header-nav__link-wrap',
        desktopLink: 'header-nav__link',
        desktopToggle: 'header-nav__submenu-toggle',
        desktopSubmenu: 'header-nav__submenu',
        desktopSubmenuItem: 'header-nav__submenu-item',
        desktopSubmenuLink: 'header-nav__submenu-link',

        mobileItem: 'mobile-menu__item',
        mobileItemHasSubmenu: 'mobile-menu__item--has-submenu',
        mobileLinkWrap: 'mobile-menu__link-wrap',
        mobileLink: 'mobile-menu__link',
        mobileToggle: 'mobile-menu__submenu-toggle',
        mobileSubmenu: 'mobile-menu__submenu',
        mobileSubmenuItem: 'mobile-menu__submenu-item',
        mobileSubmenuLink: 'mobile-menu__submenu-link',
        mobileItemOpen: 'is-submenu-open',
    };

    const replaceClass = (element, oldClass, newClass) => {
        if (!element) return;

        element.classList.remove(oldClass);
        element.classList.add(newClass);
    };

    const prepareMobileNavItem = (item) => {
        const clone = item.cloneNode(true);

        clone.className = selectors.mobileItem;

        if (item.classList.contains(selectors.desktopItemHasSubmenu)) {
            clone.classList.add(selectors.mobileItemHasSubmenu);
        }

        clone.querySelectorAll(`.${selectors.desktopLinkWrap}`).forEach((element) => {
            replaceClass(element, selectors.desktopLinkWrap, selectors.mobileLinkWrap);
        });

        clone.querySelectorAll(`.${selectors.desktopLink}`).forEach((element) => {
            replaceClass(element, selectors.desktopLink, selectors.mobileLink);
        });

        clone.querySelectorAll(`.${selectors.desktopToggle}`).forEach((element) => {
            replaceClass(element, selectors.desktopToggle, selectors.mobileToggle);
            element.setAttribute('aria-expanded', 'false');
        });

        clone.querySelectorAll(`.${selectors.desktopSubmenu}`).forEach((element) => {
            replaceClass(element, selectors.desktopSubmenu, selectors.mobileSubmenu);
        });

        clone.querySelectorAll(`.${selectors.desktopSubmenuItem}`).forEach((element) => {
            replaceClass(element, selectors.desktopSubmenuItem, selectors.mobileSubmenuItem);
        });

        clone.querySelectorAll(`.${selectors.desktopSubmenuLink}`).forEach((element) => {
            replaceClass(element, selectors.desktopSubmenuLink, selectors.mobileSubmenuLink);
        });

        return clone;
    };

    const buildMobileNav = () => {
        if (!desktopNav || !mobileNav) return;

        mobileNav.innerHTML = '';

        desktopNav.querySelectorAll(':scope > li').forEach((item) => {
            mobileNav.appendChild(prepareMobileNavItem(item));
        });
    };

    const buildMobileActions = () => {
        if (!desktopActions || !mobileActions) return;

        mobileActions.innerHTML = '';

        const clone = desktopActions.cloneNode(true);

        clone.removeAttribute('data-desktop-actions');

        mobileActions.appendChild(clone);
    };

    const buildMobileMenu = () => {
        buildMobileNav();
        buildMobileActions();
    };

    const setMenuState = (isOpen) => {
        header.classList.toggle('is-menu-open', isOpen);
        body.classList.toggle('is-lock', isOpen);

        burger?.setAttribute('aria-expanded', String(isOpen));
        mobileMenu?.setAttribute('aria-hidden', String(!isOpen));
    };

    const openMenu = () => {
        setMenuState(true);
    };

    const closeMenu = () => {
        setMenuState(false);
    };

    const closeMobileSubmenus = (exceptItem = null) => {
        if (!mobileNav) return;

        mobileNav
            .querySelectorAll(`.${selectors.mobileItem}.${selectors.mobileItemOpen}`)
            .forEach((item) => {
                if (item === exceptItem) return;

                item.classList.remove(selectors.mobileItemOpen);

                const toggle = item.querySelector(`.${selectors.mobileToggle}`);
                toggle?.setAttribute('aria-expanded', 'false');
            });
    };

    const toggleMobileSubmenu = (button) => {
        const item = button.closest(`.${selectors.mobileItem}`);

        if (!item) return;

        const isOpen = item.classList.contains(selectors.mobileItemOpen);

        closeMobileSubmenus(item);

        item.classList.toggle(selectors.mobileItemOpen, !isOpen);
        button.setAttribute('aria-expanded', String(!isOpen));
    };

    const handleMobileNavClick = (event) => {
        const submenuToggle = event.target.closest(`.${selectors.mobileToggle}`);

        if (submenuToggle) {
            event.preventDefault();
            toggleMobileSubmenu(submenuToggle);
            return;
        }

        const link = event.target.closest('a');

        if (link) {
            closeMenu();
        }
    };

    const handleMobileActionsClick = (event) => {
        const interactive = event.target.closest('a, [data-contact-modal]');

        if (interactive) {
            closeMenu();
        }
    };

    const handleScrollState = () => {
        header.classList.toggle('is-scrolled', window.scrollY > 10);
    };

    const handleResize = () => {
        if (window.innerWidth >= desktopBreakpoint) {
            closeMenu();
        }
    };

    buildMobileMenu();
    handleScrollState();

    burger?.addEventListener('click', () => {
        const isOpen = header.classList.contains('is-menu-open');

        setMenuState(!isOpen);
    });

    mobileClose?.addEventListener('click', closeMenu);
    overlay?.addEventListener('click', closeMenu);

    mobileNav?.addEventListener('click', handleMobileNavClick);
    mobileActions?.addEventListener('click', handleMobileActionsClick);

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeMenu();
        }
    });

    window.addEventListener('scroll', handleScrollState, { passive: true });
    window.addEventListener('resize', handleResize);
}